export const EVENTS = ['load', 'mousedown', 'click', 'keypress'];

export const INACTIVITY_TIME = 600000;
